import { ApiError, errorKeyForSuiteApiResult } from './errors';
import { PortalClient } from './portal-client';
import { ESuiteApiResult } from './types';

/** Typed access to branding resources exposed by the Portal. */
export class BrandingApi {
  private readonly client: PortalClient;

  public constructor(client: PortalClient) {
    this.client = client;
  }

  /** Loads the server-managed file-filter configuration used for order uploads. */
  public async getFileFilter(signal?: AbortSignal): Promise<string> {
    const result = await this.client.request<string>({
      method: 'GET',
      path: '/SuiteAPI/Branding/GetFileFilter',
      authenticated: true,
      ...(signal ? { signal } : {}),
    });

    const serverResult = result.serverResult as unknown as ESuiteApiResult;
    if (serverResult !== ESuiteApiResult.Success || typeof result.data !== 'string') {
      throw new ApiError('server', errorKeyForSuiteApiResult(serverResult), { serverResult });
    }

    return result.data;
  }
}
